<form [formGroup]="tipoProveedorCorreoForm" (ngSubmit)="onSubmit()" #tipoProveedorCorreoFormRef="ngForm">

    <div class="modal-body">

        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Nombre</label>
                <div class="col-9">
                    <input type="text" name="nombre" id="nombre" formControlName="nombre" class="form-control"
                        [attr.disabled]="detailMode?detailMode:null">
                    <div *ngIf="tipoProveedorCorreoFormRef.submitted &&( tipoProveedorCorreoForm.get('nombre').invalid ||  tipoProveedorCorreoForm.get('nombre').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="tipoProveedorCorreoForm.get('nombre').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group position-relative mx-auto">
            <div class="row">
                <label for="" class="col-2 label-control">Archivo Configuración</label>
                <div class="col-9">
                    <ngx-dropzone class="mx-auto" (change)="onSelect($event)" maxFileSize="2097152"
                        [accept]="'application/json'" multiple=false>
                        <ngx-dropzone-label class="px-5">
                            <i class="flaticon-upload"></i>
                            <p>Arrastra o selecciona un archivo de configuración de casilla</p>

                            <p>El formato del archivo debe ser .json</p>
                        </ngx-dropzone-label>
                        <!-- <ngx-dropzone-label class="d-inline">
                           
                        </ngx-dropzone-label> -->
                        <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemove(f)">
                            <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                        </ngx-dropzone-preview>
                    </ngx-dropzone>

                    <div *ngIf="tipoProveedorCorreoFormRef.submitted &&( tipoProveedorCorreoForm.get('configFile').invalid ||  tipoProveedorCorreoForm.get('configFile').dirty)"
                        class="invalid-feedback">
                        <div *ngIf="tipoProveedorCorreoForm.get('configFile').errors?.required">Campo requerido</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="submit" id="add-contact-item" class="btn btn-success add-contact-item" *ngIf="!detailMode">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">{{TipoProveedorCorreoToEdit?"Guardar":"Generar"}}</span>
        </button>
        <!-- <button type="button" id="add-contact-item" class="btn btn-warning add-contact-item" (click)="onSubmitThenContract(tipoProveedorCorreoFormRef,$event)" *ngIf="!clientToEdit && permissions.getPermission('30-20-16').asignado">
            <i class="la la-paper-plane-o d-lg-none"></i>
            <span class="d-none d-lg-block">Contrato</span>
         </button> -->
        <button type="button" class="btn btn-secondary ml-3" (click)="sendCloseRequest()">
            <span class="d-none d-lg-block">Cerrar</span>
        </button>
    </div>
</form>